import { render, staticRenderFns } from "./Div.vue?vue&type=template&id=f1e3765e&scoped=true&"
import script from "./Div.vue?vue&type=script&lang=ts&"
export * from "./Div.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e3765e",
  null
  
)

export default component.exports